'use client'

import {Button, Container, Group, Stack, Text} from '@blocks'
import {
   sitePrimaryDeepHex,
   siteTextOnDarkBandMutedHex,
   siteTypographyHeroLeadFontSizeDesktop,
   siteTypographyHeroLeadFontSizeMobile,
   siteTypographySectionLeadFontSizeDesktop,
   siteTypographySectionLeadFontSizeMobile
} from '@constants'
import {IconArrowRight} from '@icons'
import {useMediaQuery} from '@mantine/hooks'
import RotatingText from '../RotatingText'

export const HeroContent = () => {
   const isDesktop = useMediaQuery('(min-width: 768px)')

   return (
      <div
         style={{
            position: 'relative',
            zIndex: 1,
            padding: isDesktop ? '200px 0 120px' : '100px 0 88px'
         }}
      >
         <Container size={'xl'}>
            <Stack
               gap={36}
               justify={'flex-start'}
            >
               <Group
                  align={'flex-start'}
                  justify={'flex-start'}
                  gap={24}
                  wrap={isDesktop ? 'nowrap' : 'wrap'}
               >
                  <Text
                     c={'white'}
                     fz={isDesktop ? 86 : 54}
                     fw={700}
                     lh={0.8}
                     ta={'left'}
                  >
                     Clean Cars.
                  </Text>
                  <Text
                     c={'white'}
                     fz={isDesktop ? 86 : 54}
                     fw={900}
                     lh={0.8}
                     ta={'left'}
                  >
                     <RotatingText
                        texts={['Fast', 'Easy', 'Local']}
                        transition={{
                           type: 'spring',
                           damping: 25,
                           stiffness: 300
                        }}
                        initial={{y: '100%', opacity: 1}}
                        animate={{y: 0, opacity: 1}}
                        exit={{y: '-120%', opacity: 0}}
                        animatePresenceMode={'wait'}
                        animatePresenceInitial={false}
                     />
                  </Text>
               </Group>
               <Text
                  c={siteTextOnDarkBandMutedHex}
                  fz={
                     isDesktop
                        ? siteTypographyHeroLeadFontSizeDesktop
                        : siteTypographyHeroLeadFontSizeMobile
                  }
                  fw={500}
                  lh={1.4}
                  ta={'left'}
                  maw={isDesktop ? '70%' : '90%'}
               >
                  Automatic wash, self-serve bays, vacuums, dog wash,
                  detailing and grooming — all in one place in
                  Morrinsville.
               </Text>
               <Group>
                  <Button
                     c={sitePrimaryDeepHex}
                     fz={
                        isDesktop
                           ? siteTypographySectionLeadFontSizeDesktop
                           : siteTypographySectionLeadFontSizeMobile
                     }
                     fw={700}
                     size={isDesktop ? 'xl' : 'lg'}
                     radius={'xl'}
                     variant={'white'}
                     rightSection={<IconArrowRight />}
                     onClick={() =>
                        document
                           .getElementById('services')
                           ?.scrollIntoView({behavior: 'auto'})
                     }
                  >
                     Explore services
                  </Button>
               </Group>
            </Stack>
         </Container>
      </div>
   )
}
